<template lang="html">
  <div>
    <v-dialog
      v-model="InviteMemberDialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
    <v-overlay :value="progress">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
      <v-card :style="stylechat">
        <v-layout row wrap justify-center align-center class="mt-3 pl-3 pr-3">
          <v-col
            cols="2"
            justify="center"
            align="start"
            class="pl-2 pr-0 pt-0 pb-0"
            @click="closeDialog"
          >
            <v-icon class="fz-30">mdi-chevron-left</v-icon>
          </v-col>
          <v-col
            cols="7"
            justify="center"
            align="center"
            class="pa-0"
          >
            <span class="tab-title">{{$t('Dialog.group.headerInvite')}}</span>
          </v-col>
          <v-col
            cols="3"
            justify="center"
            align="center"
            class="pr-2 pl-0 pt-0 pb-0"
            v-if="InviteMemberDetail.state === 'active'"
            >
            <span :class="selected.length !== 0 ? 'icon-color' : 'icon-color-edit'" @click="InviteMemberGroup()">{{$t('RightSide.menu.invite')}}</span>
          </v-col>
          <v-col
            cols="2"
            justify="center"
            align="center"
            class="pr-2 pl-0 pt-0 pb-0"
            v-else
            >
          </v-col>
        </v-layout>
        <v-divider class="mt-4 mb-2"></v-divider>
        <v-layout row wrap justify-start align-center class="pt-5 pl-5 pr-5 pb-3">
          <v-text-field
            ref="search"
            v-model="search"
            :placeholder="$t('LeftSide.addFiend.searching')"
            prepend-inner-icon="mdi-magnify"
            solo
            dense
            hide-details
            clearable
          ></v-text-field>
        </v-layout>
        <v-layout row wrap justify-start align-start class="pl-5 pr-5 pb-5">
          <v-list v-if="FilterListFriend.length !== 0" :class="selected.length !== 0 ? 'list-overflow-select' : 'list-overflow'">
            <v-subheader v-if="FilterListFriend.length !== 0">{{$t('LeftSide.header.friend')}} ({{FilterListFriend.length}})</v-subheader>
              <template v-for="(item, index) in FilterListFriend">
                <v-list-item
                  :key="item.tokenuser"
                >
                  <template v-slot:default="{ active, toggle }">
                    <v-list-item-avatar>
                      <v-img v-if="item.profilepicture" :src="item.profilepicture" class="img-position"></v-img>
                      <img v-else-if="item.type === 'bot'" :src="`${publicPath}/assets/img/default_profile/bot-white.png`" alt="" class="img-position">
                      <img v-else-if="item.type === 'business'" :src="`${publicPath}/assets/img/default_profile/business-white.png`" alt="" class="img-position">
                      <img v-else :src="`${publicPath}/assets/img/default_profile/man-white.png`" alt="" class="img-position">
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title v-text="item.name" class="text-overflow">
                      </v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action class="pb-2">
                      <v-checkbox v-model="selected" :value="item" class="checkbox-color">
                      </v-checkbox>
                    </v-list-item-action>
                  </template>
                </v-list-item>
                <v-divider
                  v-if="index < FilterListFriend.length - 1"
                  :key="index"
                ></v-divider>
              </template>
          </v-list>

        </v-layout>
        <!-- selected -->
        <div v-if="selected.length !== 0" class="pa-2">
          <span class="pl-2 pt-2">{{$t('LeftSide.friend.haveMember', { count: selected.length }) }}</span>
          <v-row justify="space-around">
            <v-col
              cols="12"
              sm="10"
              md="8"
            >
              <v-sheet
                elevation="10"
                class="px-1"
              >
                <v-chip-group
                  active-class=""
                >
                  <v-chip
                    v-for="(tag, i) in selected"
                    :key="i"
                    close
                    @click:close="removeListAddGroup(tag)"
                  >
                  <v-avatar>
                    <img v-if="tag.profilepicture" :src="tag.profilepicture" :alt="tag.name" class="img-position">
                    <img v-else-if="tag.type === 'business'" :src="`${publicPath}/assets/img/default_profile/business-white.png`" class="img-position" :alt="tag.name">
                    <img v-else-if="tag.type === 'government'" :src="`${publicPath}/assets/img/default_profile/business-white.png`" class="img-position" :alt="tag.name">
                    <img v-else-if="tag.type === 'bot'" :src="`${publicPath}/assets/img/default_profile/bot-white.png`" class="img-position" :alt="tag.name">
                    <img v-else :src="`${publicPath}/assets/img/default_profile/man-white.png`" class="img-position" :alt="tag.name">
                  </v-avatar>
                  <span class="text-overflow-badge">{{tag.name}}</span>
                  </v-chip>
                </v-chip-group>
              </v-sheet>
            </v-col>
          </v-row>
        </div>
      </v-card>
    </v-dialog>
    <ErrorDialog :ErrorDialog="ErrorDialog" :ErrorDialogDetail="ErrorDialogDetail" @closeAlertDialog="closeAlertDialog"/>
    <WarningDialog :WarningDialog="WarningDialog" :WarningDialogDetail="WarningDialogDetail" @emitWarning="emitWarning" @closeAlertDialog="closeAlertDialog"/>
  </div>
</template>

<script>
import WarningDialog from '@/components/Alert/Warning'
import ErrorDialog from '@/components/Alert/Error'
var _ = require('lodash')
export default {
  props: {
    InviteMemberDialog: Boolean,
    InviteMemberDetail: {}
  },
  data() {
    return {
      publicPath: process.env.VUE_APP_BASE_PATH,
      selected: [],
      FriendList: [],
      ErrorDialogDetail: {},
      ErrorDialog: false,
      WarningDialogDetail: {},
      WarningDialog: false,
      data_user: {},
      edit_member: false,
      member_active: [],
      member_pending: [],
      progress: false,
      search: '',
      stylechat: {
        "--InviteMember-HeaderColor": "white",
        "--InviteMember-TabBackground": "white",
        "--InviteMember-Icon": "gray",
        "--InviteMember-IconActive": "#2662ae",
        "--InviteMember-Background": "white",
        "--InviteMember-FontSize": "18px",
        "--InviteMember-FontSize-Title": "24px",
        "--InviteMember-FontColor": "back",
        "--InviteMember-FontSize-Status": "16px",
        "--InviteMember-FontColor-Status": "grey",
        "--InviteMember-Background-Input": "#E2E1E3",
        "--InviteMember-Color-Button": "#EFF2FE",
        "--InviteMember-FontColor-Button": "#2662ae",
        "--InviteMember-FontColor-Block-Button": "#cb1002",
        "--InviteMember-FontColor-Dis-Button": "#e2e1e3",
        "--InviteMember-Btn-Confirm-Background": "#2662ae",
        "--InviteMember-Btn-Confirm-Color": "white",
        "--InviteMember-Btn-Confirm-FontSize": "18px",
        "--InviteMember-Btn-Cancel-Background": "white",
        "--InviteMember-Btn-Cancel-Color": "#2662ae",
        "--InviteMember-Btn-Cancel-FontSize": "18px",
        "--InviteMember-Btn-Leave-Background": "white",
        "--InviteMember-Btn-Leave-Color": "#ff5252",
        "--InviteMember-Btn-Leave-FontSize": "18px"
      },
    }
  },
  components: {
    WarningDialog,
    ErrorDialog
  },
  computed: {
    FilterListFriend () {
      if (this.search !== '' && this.search !== null) {
        return this.FriendList.filter(post => {
          return post.name.toLowerCase().includes(this.search.toLowerCase())
        })
      } else {
        return this.FriendList
      }
    },
  },
  watch: {
    InviteMemberDialog () {
      if (this.InviteMemberDialog) {
        // console.log(this.InviteMemberDetail)
        this.member_active = _.filter(this.InviteMemberDetail.member, function (o) { return o.statemember === 'active' })
        this.member_pending = _.filter(this.InviteMemberDetail.member, function (o) { return o.statemember === 'pending' })
        this.getListFriend()
      } else {
        this.selected = []
      }
    },
    selected () {
      // console.log(this.selected)
    }
  },
  created () {
    // var user_profile = JSON.parse(this.$cookie.get('user-profile'))
    var user_profile = ''
    if (JSON.parse(this.$cookie.get('user-profile') == null)) {
      user_profile = JSON.parse(localStorage.getItem('user-profile'))
    } else {
      user_profile = JSON.parse(this.$cookie.get('user-profile'))
    }
    this.data_user = user_profile['account']['profile']
  },
  methods: {
    InviteMemberGroup () {
      if (this.selected.length !== 0) {
        this.progress = true
        this.axios.post(process.env.VUE_APP_API_GO + `/v1/invite-group`, {
          group_id: this.InviteMemberDetail.group_id,
          tokenuser: this.data_user.tokenuser,
          listmember: _.map(this.selected, 'tokenuser')
        }).then((response) => {
          if (response.data.status === 'success') {
            this.progress = false
            this.closeDialog()
          }
        }).catch(err => {
          console.log(err)
          this.progress = false
          this.ErrorDialogDetail = {
            title: 'Error',
            text: this.$t('Alert.Fail.default.somethingWrong')
          }
          this.ErrorDialog = true
        })
      }
    },
    removeListAddGroup (item) {
      // console.log(item)
      this.selected.splice(this.selected.indexOf(item), 1)
    },
    getListFriend () {
      this.progress = true
      this.axios.post(process.env.VUE_APP_API_GO + '/v1/get-list-friend', {
          tokenuser: this.data_user.tokenuser
        }).then((response) => {
          if (response.data.status === 'success') {
            this.progress = false
            this.FriendList = response.data['list_friend']
            this.FriendList = _.differenceBy(this.FriendList, this.member_active, 'tokenuser')
            this.FriendList = _.differenceBy(this.FriendList, this.member_pending, 'tokenuser')
          }
        // console.log(this.FriendList)
      }).catch(err => {
        console.log(err)
        this.selected = []
        this.progress = false
        this.ErrorDialogDetail = {
          title: 'Error',
          text: this.$t('Alert.Fail.default.somethingWrong')
        }
        this.ErrorDialog = true
      })
    },
    closeAlertDialog (data) {
      if (data.type === 'warning') {
        this.WarningDialog = data.value
      } else if (data.type === 'err') {
        this.ErrorDialog = data.value
      }
    },
    emitWarning (item) {
      this.WarningDialog = false
      if (item.type === 'kickgroup') {
        this.kickGroup(item)
      } else if (item.type === 'cancelinvite') {
        this.cancelInvite(item)
      }
    },
    openDialog (item, index, type) {
      // console.log(item)
      if (type === 'kickgroup') {
        this.WarningDialogDetail = {
          title: this.$t('Alert.Sure'),
          text: this.$t('Alert.Right.deleteFriendGroup', {name: item.name}),
          detail: item,
          index: index,
          type: 'kickgroup'
        }
        this.WarningDialog = true
      } else if (type === 'cancelinvite') {
        this.WarningDialogDetail = {
          title: this.$t('Alert.Sure'),
          text: this.$t('Alert.Right.cancelInvite', {name: item.name}),
          detail: item,
          index: index,
          type: 'cancelinvite'
        }
        this.WarningDialog = true
      }
    },
    closeDialog() {
      this.selected = []
      this.search = ''
      this.member_active = []
      this.member_pending = []
      this.FriendList = []
      this.$emit('closeComponents', {
        name: 'invitemember',
        value: false
      })
      // this.edit_member = false
    },
    editGroup (value) {
      this.edit_member = value
    }
  },
}
</script>

<style lang="css" scoped>
.checkbox-color {
  color: var(--InviteMember-IconActive) !important;
}
>>>.v-application .elevation-10 {
  box-shadow: none !important;
}
>>>.theme--light.v-sheet {
  box-shadow: none !important;
}
.list-overflow {
  height: calc(100vh - 120px) !important;
  overflow-y: auto;
  /* background-color: bisque; */
  width: 100% !important;
}
.list-overflow::-webkit-scrollbar {
  width: 3px;
}

.list-overflow::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, .1);
}

.list-overflow-select {
  height: calc(100vh - 210px) !important;
  overflow-y: auto;
  /* background-color: bisque; */
  width: 100% !important;
}
.list-overflow-select::-webkit-scrollbar {
  width: 3px;
}

.list-overflow-select::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, .1);
}
/* >>>.v-input__slot {
  background-color: var(--InviteMember-Background-Input) !important;
  border-radius: 10px !important;
} */
>>>.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
  box-shadow: none !important;
  background-color: var(--InviteMember-Background-Input) !important;
  border-radius: 10px !important;
}
>>>.v-dialog--fullscreen {
  border-radius: 0;
  margin: 0;
  height: 100%;
  position: fixed;
  /* overflow-y: auto; */
  top: 0;
  left: 0;
  overflow: hidden;
}
>>>.v-sheet.v-card:not(.v-sheet--outlined) {
  box-shadow: none !important;
}
.icon-color-edit {
  color: var(--InviteMember-Icon) !important;
}
.icon-color {
  color: var(--InviteMember-IconActive) !important;
}
.btn-confirm {
  background-color: var(--InviteMember-Btn-Confirm-Background) !important;
  color: var(--InviteMember-Btn-Confirm-Color) !important;
  font-size: var(--InviteMember-Btn-Confirm-FontSize) !important;
  font-weight: 600;
}
.btn-cancel {
  background-color: var(--InviteMember-Btn-Cancel-Background) !important;
  color: var(--InviteMember-Btn-Cancel-Color) !important;
  font-size: var(--InviteMember-Btn-Cancel-FontSize) !important;
  font-weight: 600;
}
.btn-leave {
  background-color: var(--InviteMember-Btn-Leave-Background) !important;
  color: var(--InviteMember-Btn-Leave-Color) !important;
  font-size: var(--InviteMember-Btn-Leave-FontSize) !important;
  font-weight: 600;
}
.img-position {
  object-fit: cover;
  object-position: 50% 0;
  border-style: solid;
  border-width: thin;
  border-color: #e8e8e8;
}
.layout-page {
  /* height: calc(100vh - 64px) !important; */
  height: 100vh !important;
  overflow: hidden !important;
  background-color: var(--InviteMember-Background) !important;
}
.fz-30 {
  font-size: 30px;
}
.text-transform {
  text-transform: none;
}
.text-title {
  font-size: var(--InviteMember-FontSize-Title) !important;
  color: var(--InviteMember-FontColor) !important;
  font-weight: 600;
}
.tab-title {
  color: var(--InviteMember-FontColor) !important;
  font-size: var(--InviteMember-FontSize) !important;
  font-weight: 600;
}
.tab-title-status {
  color: var(--InviteMember-FontColor-Status) !important;
  font-size: var(--InviteMember-FontSize-Status) !important;
}
.text-overflow {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 70vw;
}
</style>
